
  import {
    Component,
    Model,
    Prop,
    Vue,
    Watch
  } from "vue-property-decorator";
  import Dialog from '@/components/dialog.vue';

  @Component({
    name: 'create-refund-address',
    components: {
      'slz-dialog': Dialog
    }
  })
  export default class CreateRefundAddress extends Vue {
    @Model('change') isShow!: boolean;
    private formData: any = {
      name: '',
      phone: '',
      address: ''
    }
    private showDialog = false

    @Watch('isShow')
    private onChangeShow(val) {
      this.showDialog = val
    }

    // 关闭
    private handleClose() {
      this.showDialog = false;
      this.$emit('change', false)
    }
  }
